export const DOCUMENT_CODE = {
  'BRA:AEA': 'BRA:AEA',
  'BRA:CTPS': 'BRA:CTPS',
  'BRA:PIS': 'BRA:PIS',
  'BRA:TE': 'BRA:TE',
  'BRA:CR': 'BRA:CR',
  'BRA:RE': 'BRA:RE',
  'BRA:QC': 'BRA:QC',
  'BRA:HD': 'BRA:HD',
  'BRA:CC': 'BRA:CC',
  'BRA:CNF': 'BRA:CNF',
  'BRA:CAV': 'BRA:CAV',
  'BRA:FVT': 'BRA:FVT',
  // 'BRA:CONTA': 'BRA:CONTA',
  'BRA:CRI': 'BRA:CRI',
  'BRA:CPF': 'BRA:CPF',
  'BRA:RG': 'BRA:RG',
  'BRA:OAB': 'BRA:OAB',
  'BRA:ASO': 'BRA:ASO',
  'BRA:RNE': 'BRA:RNE',
  // 'BRA:BNC': 'BRA:BNC',
  'USA:SSNUMBER': 'USA:SSNUMBER',
  'BRA:PCD': 'BRA:PCD',
};
